const URL_BACKEND = "https://www.factorinvesting.eu/screener";
const GOOGLE_ANALYTICS = "G-6FW7MXKY0N";

export {URL_BACKEND, GOOGLE_ANALYTICS};